export default __webpack_public_path__ + "static/media/full-orc.f749ee54.jpg";